interface DocumentTitleProps {
  title: string;
  releaseDate: string;
  lastUpdated: string;
}

export const DocumentTitle = ({ title, releaseDate, lastUpdated }: DocumentTitleProps) => {
  return (
    <>
      <h1 className="text-2xl font-bold">{title}</h1>
      <div className="text-right text-sm text-gray">
        <p>リリース日: {releaseDate}</p>
        <p>最終更新日: {lastUpdated}</p>
      </div>
    </>
  );
};
